import type React from 'react'
import type { ReactElement } from 'react'

function IconCopy(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg {...props} viewBox={'0 0 24 24'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
      <path
        d={
          'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z'
        }
        fill={'currentcolor'}
      />
    </svg>
  )
}

export { IconCopy }
